import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("titan_token"));
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("titan_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  const persist = (t, u) => {
    if (t) localStorage.setItem("titan_token", t); else localStorage.removeItem("titan_token");
    if (u) localStorage.setItem("titan_user", JSON.stringify(u)); else localStorage.removeItem("titan_user");
    setToken(t); setUser(u);
  };

  const login = useCallback(async (email, password) => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      persist(data.token, data.user);
      return data.user;
    } finally { setLoading(false); }
  }, []);

  const register = useCallback(async (payload) => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/register`, payload);
      persist(data.token, data.user);
      return data.user;
    } finally { setLoading(false); }
  }, []);

  const logout = useCallback(() => persist(null, null), []);

  const refresh = useCallback(async () => {
    if (!token) return;
    try {
      const { data } = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
      persist(token, data);
    } catch { persist(null, null); }
  }, [token]);

  useEffect(() => {
    if (token) axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    else delete axios.defaults.headers.common["Authorization"];
  }, [token]);

  return (
    <AuthContext.Provider value={{ token, user, loading, login, register, logout, refresh, api: API }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
